<template>
  <div class="wrapper">
    <div id="navbar" :class="{ backgroundi: show }">
      <div class="nav-brand" data-aos="zoom-in" data-aos-duration="1500">
        <router-link to="/" data-aos="zoom-in" data-aos-duration="1500">
          <img style="height: 50px" src="../assets/new-logo.svg" alt="" />
        </router-link>
        <b-icon-list scale="2" class="fa fa-navicon" v-on:click="display"></b-icon-list>
      </div>

      <div class="bar-items" :class="{ hide: !show }">
        <div id="menu" data-aos="zoom-in" data-aos-duration="1500">
          <RouterLink to="/">{{$t("Home")}}</RouterLink>

          <RouterLink to="/services">{{$t("Services")}}</RouterLink>

          <RouterLink to="/aboutUs">{{$t("About")}}</RouterLink>

          <RouterLink to="/contact">{{$t("Contact")}}</RouterLink>
          <div class="language-selector">
            <b-dropdown id="dropdown" drop color="black">
              <template #button-content>
                <b-icon icon="globe" style="width:25px; height:30px;"></b-icon>
              </template>
              <b-dropdown-item @click="changeL('de')">Deutsch</b-dropdown-item>
              <b-dropdown-item @click="changeL('en')">English</b-dropdown-item>
              <b-dropdown-item @click="changeL('fr')">French</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid my-4">
      <h2 class="text-center">{{ $t('Terms1') }}</h2>

      <h2>{{ $t('Section1') }}</h2>
      <p>{{ $t('Section1Content') }}</p>
      <p>{{ $t('Section1_2Content') }}</p>
      <p>{{ $t('Section1_3Content') }}</p>

      <h2>{{ $t('Section2') }}</h2>
      <p>{{ $t('Section2Content') }}</p>

      <h2>{{ $t('Section3') }}</h2>
      <p>{{ $t('Section3Content') }}</p>
      <p>{{ $t('Section3_2Content') }}</p>

      <h2>{{ $t('Section4') }}</h2>
      <p>{{ $t('Section4Content') }}</p>

      <h2>{{ $t('Section5') }}</h2>
      <p>{{ $t('Section5Content') }}</p>

      <h2>{{ $t('Section6') }}</h2>
      <p>{{ $t('Section6Content') }}</p>

      <h2>{{ $t('Section7') }}</h2>
      <p>{{ $t('Section7Content') }}</p>

      <h2>{{ $t('Section8') }}</h2>
      <p>{{ $t('Section8Content') }}</p>
      <p>{{ $t('Section8_2Content') }}</p>

      <h2>{{ $t('Section9') }}</h2>
      <p>{{ $t('Section9Content') }}</p>
      <p>{{ $t('Section9_2Content') }}</p>
      <p>{{ $t('Section9_3Content') }}</p>

      <h2>{{ $t('Section10') }}</h2>
      <p>{{ $t('Section10Content') }}</p>
      <p>{{ $t('Section10_2Content') }}</p>
      <p>{{ $t('Section10_3Content') }}</p>
      <p>{{ $t('Section10_4Content') }}</p>

      <h2>{{ $t('Section11') }}</h2>
      <p>{{ $t('Section11Content') }}</p>
      <p>{{ $t('Section11_2Content') }}</p>

      <h2>{{ $t('Section12') }}</h2>
      <p>{{ $t('Section12Content') }}</p>

      <h2>{{ $t('Section13') }}</h2>
      <p>{{ $t('Section13Content') }}</p>

      <h2>{{ $t('Section14') }}</h2>
      <p>{{ $t('Section14Content') }}</p>
      <p>{{ $t('Section14_2Content') }}</p>
    </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  data() {
    return {
      show: false
    };
  },
  computed: {
    ...mapGetters(["getLanguage"]),
    language() {
      if (this.getLanguage === "en") {
        return "English";
      } else if (this.getLanguage === "de") {
        return "Deutsch";
      } else if (this.getLanguage === "it") {
        return "Italian";
      } else if (this.getLanguage === "fr") {
        return "French";
      }
      return "Shqip";
    },
  },
  methods: {
    ...mapActions(["changeLanguage"]),

    changeL(lang) {
      this.changeLanguage(lang);
      if (this.$i18n.locale !== lang) {
        this.$i18n.locale = lang;
      }
    },

    display() {
      this.show = !this.show;
    },
  },
  name: "TermsAndConditions" ,
}


</script>


<style scoped>
@import "../assets/style/service.scss";
.wrapper {
  font-family: 'Poppins', sans-serif;
}
#navbar {
  background-color: #112432 !important;
  padding: 15px 0;
}
.fa.fa-navicon {
  display: none;
}

.content p {
  text-align: center;
  font: normal normal normal 25px/33px Poppins;
  letter-spacing: -1.25px;
  color: #ffffff;
  opacity: 1;
}
.button button {
  width: 297px;
  height: 53px;
  /* UI Properties */
  background: #008eff 0% 0% no-repeat padding-box;
  opacity: 1;
  /* UI Properties */
  font: normal normal bold 19px/26px Poppins;
  letter-spacing: 0.38px;
  color: #ffffff;
  /* margin-left: 230px; */
  margin-top: 10px;
}

nav {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-top: 10px;
}

nav ul li {
  list-style-type: none;
  display: inline-block;
  padding: 10px 20px;
}

nav ul li a {
  color: white;
  text-decoration: none;
  font-weight: bold;
}
@media screen and (max-width: 1741px) {
  ul {
    text-align: center;
    background-color: black;
  }
}
@media screen and (max-width: 1441px) {
  ul {
    text-align: center;
    background-color: black;
  }
}
@media screen and (max-width: 1200px) {
  ul {
    text-align: center;
    background-color: black;
  }
}
@media screen and (max-width: 1100px) {
  ul {
    text-align: center;
    background-color: black;
  }
}
@media screen and (max-width: 900px) {
  ul {
    text-align: center;
    background-color: black;
  }
}
@media screen and (max-width: 768px) {
  ul {
    text-align: center;
    background-color: black;
  }
}
@media (max-width: 780px) {
  .b-icon.bi {
    display: inline-block;
  }
  #navbar {
    flex-direction: column;
  }
  .backgroundi {
    background-color: rgb(99, 99, 99) !important;
  }
  .fa {
    display: block;
    padding: 0 25px;
    position: absolute;
    right: 0;
    color: #fff;
    font-size: 30px;
    cursor: pointer;
    margin-top: 30px;
  }

  #menu {
    flex-direction: column;
    padding: 5px 0;
  }

  a {
    text-align: center;
    width: 100%;
    box-sizing: border-box;
    padding: 15px;
  }

  .hide {
    display: none;
  }

  .nav-brand {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    /* padding: 15px 0px; */
  }
}
@media screen and (max-width: 568px) {
  ul {
    text-align: center;
    background-color: black;
  }
}
@media screen and (max-width: 430px) {
  ul {
    text-align: center;
    background-color: black;
  }
}

#navbar {
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: transparent;
  width: 100%;
}

#menu {
  list-style-type: none;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin: 0 !important;
  padding: 0;
  /* margin-bottom: -24px; */
  margin-top: 30px;
}

a {
  padding: 20px;
}

li:hover {
  background-color: #42d392;
}

a {
  text-decoration: none;
  font-size: 18px;
  color: #fff !important;
  white-space: nowrap;
}

.fa {
  display: none;
}

@media screen and (max-width: 415px) {
  ul {
    text-align: center;
    background-color: black;
  }
}
@media screen and (max-width: 390px) {
  .b-icon.bi {
    display: inline-block;
  }
}
</style>

